import { useState, useEffect } from "react";
import { fetchPendingLeaveBalanceCount } from "../api/leaveBalanceRequests";

const POLL_INTERVAL_MS = 60_000;

const usePendingLeaveBalanceCount = (enabled: boolean): number => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;

    const poll = async () => {
      const total = await fetchPendingLeaveBalanceCount();
      if (!cancelled) setCount(total);
    };

    poll();
    const id = setInterval(poll, POLL_INTERVAL_MS);

    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [enabled]);

  return count;
};

export default usePendingLeaveBalanceCount;
